export default __webpack_public_path__ + "static/media/CoBRA_workflow.5f755fd2.png";